import React from 'react';
import HiringAssessmentList from 'src/components/recruiterPositions/recruiterTypes/HiringAssessment/HiringAssessmentList';

const HiringAssessmentListPage = () => {
	return (
		<div className='flex flex-1'>
			<HiringAssessmentList />
		</div>
	);
};

export default HiringAssessmentListPage;
